module.exports = __webpack_public_path__ + "img/person.05b9d3f6.svg";